import { SagaIterator } from 'redux-saga';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleSetSensitiveLabel } from '~src/catalog/sagas/labels/SetSensitiveLabelSaga';
import { rootConnectedApplicationSagas } from '~src/connectedApplications/sagas/ConnectedApplicationSagas';
import { rootAllowDataAccelerationSaga, rootDisallowDataAccelerationSaga } from '~src/dataAcceleration/sagas/AdminAllowDisallowDataAccelerationSaga';
import { rootDataAccelerationSaga } from '~src/dataAcceleration/sagas/DataAccelerationSaga';
import { rootAdjustAuthorConfiguredDCRSaga } from '~src/dataChangeRadar/sagas/AuthorConfiguredDCRSaga';
import { rootPublishedConnectionSaga } from '~src/publishedConnection/sagas/PublishedConnectionSaga';
import { rootPublishedConnectionTableSaga } from '~src/publishedConnectionTable/sagas/PublishedConnectionTableSaga';
import { rootResourceGovernanceSaga } from '~src/schedule/sagas/ResourceGovernanceSagas';

import { rootUserIdentityActionSaga } from '../../authentication/sagas/UserIdentitySagas';
import { rootBackgroundJobSaga } from '../../backgroundJob/sagas/BackgroundJobSagas';
import {
  ChangeExtractDsToLive,
  EditConnections,
  GroupDatabases,
  RemoveExternalContentAction,
  SetCertification,
  SetContact,
  SetDataQuality,
  SetDataQualityTrigger,
  SetDescription,
  SetSensitiveLabel,
  UngroupDatabases,
} from '../../bootstrap/redux/actions/AppActionTypes';
import { handleGroupDatabases } from '../../catalog/sagas/databases/GroupDatabasesSaga';
import { handleUngroupDatabases } from '../../catalog/sagas/databases/UngroupDatabasesSaga';
import { handleSetCertification } from '../../catalog/sagas/labels/SetCertificationSaga';
import { handleSetDataQuality } from '../../catalog/sagas/labels/SetDataQualitySaga';
import { handleSetDataQualityTrigger } from '../../catalog/sagas/labels/SetDataQualityTriggerSaga';
import { handleRemoveExternalContent } from '../../catalog/sagas/RemoveExternalContentSaga';
import { rootCollectionSaga } from '../../Collections/sagas/CollectionSagas';
import { rootDisableWorkbookAccelerationActionSaga } from '../../dataAcceleration/sagas/DisableWorkbookAccelerationSaga';
import { rootEnableWorkbookAccelerationActionSaga } from '../../dataAcceleration/sagas/EnableWorkbookAccelerationSaga';
import { handleEditDataConnectionAction } from '../../datasource/dataConnection/sagas/EditConnectionSaga';
import { rootDataAlertMenuActionSaga } from '../../dda/sagas/DataAlertMenuSagas';
import { handleChangeExtractDsToLiveAction } from '../../extractRefresh/sagas/ChangeExtractDsToLiveSaga';
import { rootExtractRefreshSaga } from '../../extractRefresh/sagas/extractRefresh/RootExtractRefreshSaga';
import { rootRunFlowTaskMenuActionSaga } from '../../flow/sagas/RunFlowTaskMenuSaga';
import { rootMetricSpaceSagas } from '../../metrics/sagas/MetricsSpaceSaga';
import { rootScheduleMenuActionSaga } from '../../schedule/sagas/ScheduleMenuSagas';
import { rootSiteMenuActionSaga } from '../../siteManagement/sagas/SiteMenuActionSagas';
import { rootGroupMenuActionSaga } from '../../userManagement/sagas/GroupMenuSagas';
import { rootServerUserMenuActionSaga } from '../../userManagement/sagas/ServerUserMenuSagas';
import { rootSiteUserMenuActionSaga } from '../../userManagement/sagas/SiteUserMenuSagas';
import { rootWorkbookSaga } from '../../workbook/sagas/WorkbookSagas';
import { rootContentDetailDialogSaga } from './content/ContentDetailDialogSaga';
import { rootContentSaga } from './content/RootContentSaga';
import { handleSetContact } from './content/SetContactSaga';
import { handleSetDescription } from './content/SetDescriptionSaga';
import { rootContentCreationSaga } from './ContentCreationSagas';
import { rootContentSelectionSaga } from './ContentSelectionSagas';

export function* rootSpacesSaga(): SagaIterator {
  yield fork(rootContentCreationSaga);
  yield fork(rootContentSaga);
  yield fork(rootContentSelectionSaga);
  yield fork(rootCollectionSaga);
  yield fork(rootConnectedApplicationSagas);
  yield fork(rootContentDetailDialogSaga);
  yield fork(rootAllowDataAccelerationSaga);
  yield fork(rootDisallowDataAccelerationSaga);
  yield fork(rootDataAccelerationSaga);
  yield fork(rootDisableWorkbookAccelerationActionSaga);
  yield fork(rootEnableWorkbookAccelerationActionSaga);
  yield fork(rootExtractRefreshSaga);
  yield fork(rootWorkbookSaga);
  yield fork(rootMetricSpaceSagas);
  yield fork(rootBackgroundJobSaga);
  yield fork(rootDataAlertMenuActionSaga);
  yield fork(rootRunFlowTaskMenuActionSaga);
  yield fork(rootScheduleMenuActionSaga);
  yield fork(rootSiteMenuActionSaga);
  yield fork(rootSiteUserMenuActionSaga);
  yield fork(rootServerUserMenuActionSaga);
  yield fork(rootUserIdentityActionSaga);
  yield fork(rootGroupMenuActionSaga);
  yield fork(rootPublishedConnectionSaga);
  yield fork(rootResourceGovernanceSaga);
  yield fork(rootPublishedConnectionTableSaga);
  yield fork(rootAdjustAuthorConfiguredDCRSaga);
  yield takeLatest(SetDataQuality, handleSetDataQuality);
  yield takeLatest(SetDataQualityTrigger, handleSetDataQualityTrigger);
  yield takeLatest(SetDescription, handleSetDescription);
  yield takeLatest(SetCertification, handleSetCertification);
  yield takeLatest(SetSensitiveLabel, handleSetSensitiveLabel);
  yield takeLatest(GroupDatabases, handleGroupDatabases);
  yield takeLatest(UngroupDatabases, handleUngroupDatabases);
  yield takeLatest(SetContact, handleSetContact);
  yield takeLatest(RemoveExternalContentAction, handleRemoveExternalContent);
  yield takeEvery(EditConnections, handleEditDataConnectionAction);
  yield takeEvery(ChangeExtractDsToLive, handleChangeExtractDsToLiveAction);
}
